import React from "react";

const ProgressLine = () => {
  return (
    <div className="flex flex-col items-center justify-center p-5">
      <div className="progress-container">
        <div className="progress-bar"></div>
      </div>

      <style>{`
        .progress-container {
          width: 16rem; 
          height: 0.75rem; 
          background-color: #e5e7eb; 
          border-radius: 9999px;
          overflow: hidden;
          position: relative;
        }

        .progress-bar {
          height: 100%;
          background-color: #00FF9D;
          border-radius: 9999px;
          width: 0%;
          animation: fillProgress 5s linear forwards;
        }

        @keyframes fillProgress {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
    </div>
  );
};

export default ProgressLine;
